import { render, staticRenderFns } from "./CancelAppointmentModal.vue?vue&type=template&id=1a897bd2"
import script from "./CancelAppointmentModal.vue?vue&type=script&lang=js"
export * from "./CancelAppointmentModal.vue?vue&type=script&lang=js"
import style0 from "./CancelAppointmentModal.vue?vue&type=style&index=0&id=1a897bd2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a897bd2')) {
      api.createRecord('1a897bd2', component.options)
    } else {
      api.reload('1a897bd2', component.options)
    }
    module.hot.accept("./CancelAppointmentModal.vue?vue&type=template&id=1a897bd2", function () {
      api.rerender('1a897bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/CancelAppointmentModal.vue"
export default component.exports